/**
 * The deck's shared dimensions. Kept in one place so the shell, the stage and the action area
 * cannot drift apart.
 */

/** Points between the card and the screen edges (9, like every toolbar control) and the header. */
export const LEARN_CARD_CLEARANCE = 9;

/** Height of the binder tabs along the top of a revealed card (the Mnemonics / Info switch). */
export const LEARN_CARD_BINDER_TAB_HEIGHT = 30;

/**
 * The concave radius where each binder tab meets the card's top edge. Flares overlap neighbouring
 * tabs at different layers; the far left and right sides align directly with the card.
 * Exception: this concave SVG join is drawing geometry, separate from the XS outer corners.
 */
export const LEARN_CARD_BINDER_TAB_FLARE_RADIUS = 8;

/** The icon-only Details binder tab is square; Learn receives the remaining room. */
export const LEARN_CARD_BINDER_DETAILS_TAB_WIDTH = LEARN_CARD_BINDER_TAB_HEIGHT;
